export class ReportImageModel {
  type!: Nullable<string>;
  url!: Nullable<string>;
  title!: Nullable<string>;
}

export default class ReportImage extends ReportImageModel {
  constructor({ type, url, title }: ReportImageModel) {
    super();

    this.type = type;
    this.url = url;
    this.title = title;
  }
}
